export default __webpack_public_path__ + "static/media/star_icon.1fced9ce.svg";